import { render } from "./SpecialProcessHome.vue?vue&type=template&id=fba8c468&scoped=true&ts=true&lang=pug"
import script from "./SpecialProcessHome.vue?vue&type=script&lang=ts"
export * from "./SpecialProcessHome.vue?vue&type=script&lang=ts"

import "./SpecialProcessHome.vue?vue&type=style&index=0&id=fba8c468&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba8c468"]])

export default __exports__